/* eslint-disable */

export const protobufPackage = "od_protos.journey.data.categories";

export interface MarketplacePropertyCategory {
  detailPageView?: MarketplacePropertyCategory_DetailPageViewEvent | undefined;
  similarHomesClick?: MarketplacePropertyCategory_SimilarHomesClickEvent | undefined;
  tourBookingStart?: MarketplacePropertyCategory_TourBookingStartEvent | undefined;
  reaction?: MarketplacePropertyCategory_ReactionEvent | undefined;
  offerStart?: MarketplacePropertyCategory_OfferStartEvent | undefined;
  share?: MarketplacePropertyCategory_ShareEvent | undefined;
  rentalScamBannerView?: MarketplacePropertyCategory_RentalScamBannerViewEvent | undefined;
  rentalScamBannerLearnMore?: MarketplacePropertyCategory_RentalScamBannerLearnMoreEvent | undefined;
}

export enum MarketplacePropertyCategory_ReactionEventReaction {
  REACTION_UNSPECIFIED = 0,
  REACTION_ADD_LIKE = 1,
  REACTION_REMOVE_LIKE = 2,
  REACTION_ADD_DISLIKE = 3,
  REACTION_REMOVE_DISLIKE = 4,
  UNRECOGNIZED = -1,
}

export interface MarketplacePropertyCategory_DetailPageViewEvent {
  addressUuid: string;
}

export interface MarketplacePropertyCategory_SimilarHomesClickEvent {
  addressUuid: string;
  clickedAddressUuid: string;
}

export interface MarketplacePropertyCategory_TourBookingStartEvent {
  addressUuid: string;
  placement: string;
}

export interface MarketplacePropertyCategory_ReactionEvent {
  addressUuid: string;
  source: string;
  reaction: MarketplacePropertyCategory_ReactionEventReaction;
}

export interface MarketplacePropertyCategory_OfferStartEvent {
  addressUuid: string;
  source: string;
}

export interface MarketplacePropertyCategory_ShareEvent {
  addressUuid: string;
  source: string;
}

export interface MarketplacePropertyCategory_RentalScamBannerViewEvent {
  addressUuid: string;
}

export interface MarketplacePropertyCategory_RentalScamBannerLearnMoreEvent {
  addressUuid: string;
}
